import React from 'react'
import Aux from '../../../hocs/Auxiliary/Auxiliary'
import styles from './Letter.module.css'

const Letter = props => {
  return (
    <Aux>
      <p className={styles.Letter}>{props.letter}</p>
    </Aux>
  )
}

export default Letter